// sportScope.js — the one place that implements "filter this list to the
// active sport." Three components (GamePlanTab, GamePlanView, HomeView)
// each hand-wrote an identical useMemo for this before 2026-10-22; a 4th
// copy-paste site could easily have drifted (e.g. `===` vs a typo'd field
// name) without anyone noticing, since nothing forced them to agree. See
// docs_zenanalytics/16-ARCHITECTURE-DATA-ISOLATION-2026-10-21.md — this is
// the frontend half of that convention, now with exactly one implementation
// instead of three.
import { useMemo } from 'react';

/**
 * Returns `items` filtered to `activeSport` (by `.sport`), or `items`
 * unchanged if no sport is active. Memoized on [items, activeSport] —
 * identical behavior to the three call sites this replaces.
 */
export function useSportFiltered(items, activeSport) {
  return useMemo(
    () => (activeSport ? items.filter(p => p.sport === activeSport) : items),
    [items, activeSport]
  );
}
